import React from 'react';
import PatientPreviewForm from '../../../components/PatientPreviewForm/PatientPreviewForm';


function PatientPreview() {
  return (
    <PatientPreviewForm />
  )
}

export default PatientPreview